var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"mx-4 pt-6",attrs:{"append-icon":"mdi-magnify","label":"Buscar","value":_vm.value},on:{"input":function (val) {
      _vm.listenSearch(val);
    }}})}
var staticRenderFns = []

export { render, staticRenderFns }